

// — STEP 6: Complete —
const EvaluationComplete = ({ confirmationCode, managerEmail })  =>{
  return (
    <div className="evaluation-step-container">
      <h2>Complete!</h2>
      <p>Thank you for completing SWP's Athlete Listening Survey.</p>
      <p>
        Confirmation Code: <strong>{confirmationCode}</strong>
      </p>
      <p>
        Your anonymous feedback will help your organization improve athlete safety and inclusion. You're making a difference for current and future athletes.
      </p>
      <p>
        Questions or concerns? Email us at {managerEmail} . Learn more about SWP
        at <strong>lassosafe.com</strong>.
      </p>
      <br></br>
      <p>— SWP Team</p>
    </div>
  );
}

export default EvaluationComplete;
